<template>
  <div>
    <template v-if="status == 'loading'">
      <div
        class="d-flex justify-content-center align-items-center mb-3"
        style="height: 100%"
      >
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </template>
    <div v-show="status !== 'loading'">
     <router-view></router-view>
    </div>
  </div>
</template>
<script>

export default {
  name: "RegisterSteps",
  computed:{
    status() {
      return this.$store.getters["auth/authStatus"];
    },
  }
};
</script>
<style lang="scss">
//TODO o componente deve aceitar variaveis de mixins @extend %shadow-sm;

.checkPassword {
  background:  var(--white);
  position: absolute;
  width: 99%;
  z-index: 2;
  transform: translateX(-15px);
  padding: 1em 1em;
  box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.1) !important;
  &__list {
    @media only screen and (min-width: 1800px) {
      column-count: 2;
    }
  }

  &__item{
    margin: 0 0 .5em;
    font-size: 12px;
    &.is-valid {
      color: var(--success);
    }
  }

  .btn {
    height: 50px !important;
  }
}
</style>
